import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconRedditBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconRedditBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '71a1299e75939ceb92ccab526cfdfc6cb821b58c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '5f44cb7b513cdcd887b9092e7e9a55dd0fcc4afb', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '23d4a040d5d2aea998e7311caf23a66009e5a4f9', d: "M20.62 11.442a2.033 2.033 0 0 0-2.036-2.035 2.05 2.05 0 0 0-1.418.567c-1.401-1-3.32-1.652-5.456-1.735l.935-4.371 3.036.65A1.453 1.453 0 1 0 17.132 3a1.45 1.45 0 0 0-1.3.818L12.445 3.1c-.1-.017-.2 0-.267.05a.33.33 0 0 0-.15.234l-1.035 4.872c-2.169.066-4.121.717-5.54 1.735a2.05 2.05 0 0 0-1.417-.567A2.033 2.033 0 0 0 3.2 13.31c-.033.2-.05.4-.05.617 0 3.137 3.654 5.69 8.159 5.69s8.159-2.536 8.159-5.69c0-.2-.017-.417-.05-.617a2.06 2.06 0 0 0 1.201-1.869M6.638 12.894a1.453 1.453 0 0 1 2.903 0c0 .8-.65 1.451-1.451 1.451-.801.017-1.452-.65-1.452-1.451m8.126 3.854c-1.001 1.001-2.903 1.068-3.454 1.068-.567 0-2.47-.083-3.454-1.068a.373.373 0 0 1 0-.534c.15-.15.384-.15.534 0 .634.634 1.969.851 2.92.851s2.303-.217 2.92-.85a.37.37 0 0 1 .534 0 .406.406 0 0 1 0 .533m-.267-2.386a1.453 1.453 0 0 1 0-2.903c.8 0 1.451.65 1.451 1.452 0 .784-.65 1.451-1.451 1.451", fill: "#FF4500" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-reddit-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-reddit-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-reddit-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconRedditBranded$1);
            }
            break;
    } });
}

const CosmosIconRedditBranded = CosmosIconRedditBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconRedditBranded, defineCustomElement };
